import CryptoList from "./components/CryptoList";
import "./styles.css";
export default function App() {
  return (
    <div>
      <CryptoList />
    </div>
  );
}